












import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { parsePeriodListItem, comparePeriods } from '@/utils';
import {
    DateRangeMapper,
    IFormControl,
    IListItem,
    IPeriodShort
} from '@/entities';

@Component({})
export default class DateRangeWeeklyComponent extends Vue {
    @Prop() public dateRangeHints: IListItem[];
    @Prop({ default: null }) public dateRangeStart: IFormControl;
    @Prop({ default: null }) public dateRangeEnd: IFormControl;
    @Prop({ default: null }) public label: string;

    public dateRangeHint: IFormControl = {
        key: 'dateRangeHintId',
        label: this.label,
        value: null
    };

    public created() {
        if (this.dateRangeStart) {
            this.adjustHint(this.dateRangeStart.value);
        }
        if (this.dateRangeEnd) {
            this.adjustHint(this.dateRangeEnd.value);
        }
    }

    public datePeriodChange() {
        if (!this.dateRangeHint.value) {
            return;
        }
        const period = parsePeriodListItem(this.dateRangeHint.value);
        if (this.dateRangeStart) {
            this.dateRangeStart.value.start = period.start;
        }
        if (this.dateRangeEnd) {
            this.dateRangeEnd.value.end = period.end;
        }
    }

    @Watch('dateRangeStart.value.start')
    public onStartChange($event) {
        if (this.dateRangeStart.value) {
            this.adjustHint(this.dateRangeStart.value);
        }
    }

    @Watch('dateRangeEnd.value.end')
    public onEndChange($event) {
        if (this.dateRangeEnd.value) {
            this.adjustHint(this.dateRangeEnd.value);
        }
    }

    private adjustHint(dateRangePeriod: IPeriodShort) {
        if (!dateRangePeriod) {
            return;
        }
        const hint = this.findHintValue(dateRangePeriod);
        this.dateRangeHint.value = hint ? hint : null;
    }

    private findHintValue(period: IPeriodShort) {
        for (let hint of this.dateRangeHints) {
            if (hint.value != null) {
                const hintPeriod = parsePeriodListItem(hint.value);
                if (this.dateRangeStart && this.dateRangeEnd) {
                    if (comparePeriods(period, hintPeriod)) {
                        return hint.value;
                    }
                } else {
                    if (this.dateRangeStart) {
                        if (period.start.getTime() === hintPeriod.start.getTime()) {
                            return hint.value;
                        }
                    }
                    if (this.dateRangeEnd) {
                        if (period.end.getTime() === hintPeriod.end.getTime()) {
                            return hint.value;
                        }
                    }
                }
            }
        }
        return null;
    }
}
